import React from "react";

function LandIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2250"
      height="1313"
      viewBox="0 0 467.4 245.4"
    >
      <path
        fill="#58595b"
        d="M233.7 0C104.6 0 0 54.9 0 122.7c0 67.7 104.6 122.7 233.7 122.7 129 0 233.7-54.9 233.7-122.7C467.4 54.9 362.7 0 233.7 0"
      />
      <path
        fill="#595a5c"
        d="M233.7 0C104.6 0 0 54.9 0 122.7c0 67.7 104.6 122.6 233.6 122.6s233.7-54.9 233.7-122.6C467.3 54.9 362.7 0 233.7 0"
      />
      <path
        fill="#5a5b5d"
        d="M233.7.1C104.7.1.1 55 .1 122.7c0 67.7 104.6 122.6 233.6 122.6s233.6-54.9 233.6-122.6C467.3 55 362.7.1 233.7.1"
      />
      <path
        fill="#5b5c5e"
        d="M233.7.1C104.7.1.1 55 .1 122.7c0 67.7 104.6 122.6 233.6 122.6s233.6-54.9 233.6-122.6C467.3 55 362.7.1 233.7.1"
      />
      <path
        fill="#5c5c5f"
        d="M233.7.1C104.7.1.1 55 .1 122.7c0 67.7 104.6 122.6 233.6 122.6s233.6-54.9 233.6-122.6C467.3 55 362.7.1 233.7.1"
      />
      <path
        fill="#5c5d60"
        d="M233.7.1C104.7.1.1 55 .1 122.7c0 67.7 104.6 122.6 233.5 122.6 129 0 233.6-54.9 233.6-122.6C467.2 55 362.7.1 233.7.1"
      />
      <path
        fill="#5d5e60"
        d="M233.7.1C104.7.1.2 55 .2 122.7c0 67.7 104.6 122.5 233.5 122.5 129 0 233.5-54.9 233.5-122.5C467.2 55 362.7.1 233.7.1"
      />
      <path
        fill="#5e5f61"
        d="M233.7.2C104.7.2.2 55 .2 122.7s104.5 122.5 233.5 122.5 233.5-54.9 233.5-122.5C467.2 55 362.6.2 233.7.2"
      />
      <path
        fill="#5f6062"
        d="M233.7.2C104.8.2.2 55 .2 122.7c0 67.6 104.5 122.5 233.5 122.5 128.9 0 233.5-54.8 233.5-122.5S362.6.2 233.7.2"
      />
      <path
        fill="#606163"
        d="M233.7.2C104.8.2.3 55.1.3 122.7s104.5 122.5 233.4 122.5 233.5-54.8 233.5-122.5C467.2 55.1 362.6.2 233.7.2"
      />
      <path
        fill="#616264"
        d="M233.7.3C104.8.3.3 55.1.3 122.7c0 67.6 104.5 122.4 233.4 122.4s233.4-54.8 233.4-122.4C467.1 55.1 362.6.3 233.7.3"
      />
      <path
        fill="#616265"
        d="M233.7.3C104.8.3.3 55.1.3 122.7c0 67.6 104.5 122.4 233.4 122.4s233.4-54.8 233.4-122.4C467.1 55.1 362.6.3 233.7.3"
      />
      <path
        fill="#626366"
        d="M233.7.3C104.8.3.3 55.1.3 122.7c0 67.6 104.5 122.4 233.4 122.4s233.4-54.8 233.4-122.4C467.1 55.1 362.6.3 233.7.3"
      />
      <path
        fill="#636467"
        d="M233.7.3C104.8.3.4 55.1.4 122.7c0 67.6 104.5 122.4 233.3 122.4 128.9 0 233.4-54.8 233.4-122.4C467.1 55.1 362.6.3 233.7.3"
      />
      <path
        fill="#646567"
        d="M233.7.3C104.9.3.4 55.1.4 122.7.4 190.3 104.9 245 233.7 245 362.6 245 467 190.3 467 122.7S362.6.3 233.7.3"
      />
      <path
        fill="#656668"
        d="M233.7.4C104.9.4.4 55.1.4 122.7S104.9 245 233.7 245 467 190.3 467 122.7 362.5.4 233.7.4"
      />
      <path
        fill="#656769"
        d="M233.7.4C104.9.4.4 55.2.4 122.7S104.9 245 233.7 245 467 190.2 467 122.7 362.5.4 233.7.4"
      />
      <path
        fill="#66686a"
        d="M233.7.4C104.9.4.5 55.2.5 122.7S104.9 245 233.7 245C362.5 245 467 190.2 467 122.7S362.5.4 233.7.4"
      />
      <path
        fill="#67686b"
        d="M233.7.4C104.9.4.5 55.2.5 122.7S104.9 245 233.7 245C362.5 245 467 190.2 467 122.7S362.5.4 233.7.4"
      />
      <path
        fill="#68696c"
        d="M233.7.5C104.9.5.5 55.2.5 122.7s104.4 122.2 233.2 122.2c128.8 0 233.2-54.7 233.2-122.2S362.5.5 233.7.5"
      />
      <path
        fill="#696a6c"
        d="M233.7.5C105 .5.6 55.2.6 122.7S105 244.9 233.8 244.9c128.8 0 233.2-54.7 233.2-122.2C466.9 55.2 362.5.5 233.7.5"
      />
      <path
        fill="#696b6d"
        d="M233.7.5C105 .5.6 55.2.6 122.7S105 244.9 233.7 244.9c128.8 0 233.2-54.7 233.2-122.2S362.5.5 233.7.5"
      />
      <path
        fill="#6a6c6e"
        d="M233.7.5C105 .5.6 55.2.6 122.7S105 244.8 233.7 244.8s233.1-54.7 233.1-122.1C466.9 55.2 362.5.5 233.7.5"
      />
      <path
        fill="#6b6c6f"
        d="M233.7.6C105 .6.6 55.3.6 122.7c0 67.4 104.4 122.1 233.1 122.1s233.1-54.7 233.1-122.1C466.8 55.3 362.5.6 233.7.6"
      />
      <path
        fill="#6c6d70"
        d="M233.7.6C105 .6.7 55.3.7 122.7c0 67.4 104.4 122.1 233.1 122.1s233.1-54.7 233.1-122.1C466.8 55.3 362.4.6 233.7.6"
      />
      <path
        fill="#6d6e70"
        d="M233.7.6C105 .6.7 55.3.7 122.7c0 67.4 104.3 122.1 233 122.1s233.1-54.7 233.1-122.1C466.8 55.3 362.4.6 233.7.6"
      />
      <path
        fill="#6d6f71"
        d="M233.7.6C105 .6.7 55.2.7 122.7c0 67.4 104.3 122.1 233 122.1s233-54.7 233-122.1C466.8 55.3 362.4.6 233.7.6"
      />
      <path
        fill="#6e7072"
        d="M233.7.7C105 .7.7 55.3.7 122.7s104.3 122 233 122 233-54.6 233-122S362.4.7 233.7.7"
      />
      <path
        fill="#6f7073"
        d="M233.7.7C105 .7.7 55.3.7 122.7s104.3 122 233 122 233-54.6 233-122S362.4.7 233.7.7"
      />
      <path
        fill="#707174"
        d="M233.7.7C105.1.7.8 55.3.8 122.7s104.3 122 232.9 122c128.6 0 233-54.6 233-122S362.4.7 233.7.7"
      />
      <path
        fill="#707274"
        d="M233.7.7C105.1.7.8 55.4.8 122.7s104.3 122 232.9 122c128.6 0 232.9-54.6 232.9-122C466.7 55.4 362.4.7 233.7.7"
      />
      <path
        fill="#717375"
        d="M233.8.8C105.1.8.9 55.4.9 122.7c0 67.3 104.3 121.9 232.9 121.9 128.6 0 232.9-54.6 232.9-121.9C466.7 55.4 362.4.8 233.8.8"
      />
      <path
        fill="#727476"
        d="M233.8.8C105.2.8.9 55.4.9 122.7c0 67.3 104.3 121.9 232.9 121.9 128.6 0 232.9-54.6 232.9-121.9C466.6 55.4 362.4.8 233.8.8"
      />
      <path
        fill="#737477"
        d="M233.8.8C105.2.8.9 55.4.9 122.7c0 67.3 104.2 121.9 232.8 121.9 128.6 0 232.9-54.6 232.9-121.9C466.6 55.4 362.3.8 233.8.8"
      />
      <path
        fill="#747578"
        d="M233.8.8C105.2.8.9 55.4.9 122.7c0 67.3 104.2 121.9 232.8 121.9 128.6 0 232.8-54.6 232.8-121.9C466.6 55.4 362.3.8 233.8.8"
      />
      <path
        fill="#747678"
        d="M233.8.9C105.2.9 1 55.4 1 122.7s104.2 121.9 232.8 121.9c128.6 0 232.8-54.6 232.8-121.8C466.6 55.4 362.3.9 233.8.9"
      />
      <path
        fill="#757779"
        d="M233.8.9C105.2.9 1 55.4 1 122.7s104.2 121.8 232.8 121.8c128.5 0 232.8-54.5 232.8-121.8C466.5 55.4 362.3.9 233.8.9"
      />
      <path
        fill="#76777a"
        d="M233.8.9C105.2.9 1 55.5 1 122.7 1 190 105.2 244.5 233.8 244.5c128.5 0 232.8-54.5 232.8-121.8C466.5 55.5 362.3.9 233.8.9"
      />
      <path
        fill="#77787b"
        d="M233.8.9C105.3.9 1.1 55.5 1.1 122.7c0 67.2 104.2 121.8 232.7 121.8S466.5 190 466.5 122.7C466.5 55.5 362.3.9 233.8.9"
      />
      <path
        fill="#77797b"
        d="M233.8 1C105.3 1 1.1 55.5 1.1 122.7s104.2 121.7 232.7 121.7 232.7-54.5 232.7-121.7S362.3 1 233.8 1"
      />
      <path
        fill="#787a7c"
        d="M233.8 1C105.3 1 1.1 55.5 1.1 122.7s104.2 121.7 232.7 121.7 232.7-54.5 232.7-121.7S362.3 1 233.8 1"
      />
      <path
        fill="#797a7d"
        d="M233.8 1C105.3 1 1.1 55.5 1.1 122.7s104.2 121.7 232.6 121.7c128.5 0 232.7-54.5 232.7-121.7S362.3 1 233.8 1"
      />
      <path
        fill="#7a7b7e"
        d="M233.8 1C105.3 1 1.2 55.5 1.2 122.7s104.1 121.7 232.6 121.7 232.6-54.5 232.6-121.7S362.2 1 233.8 1"
      />
      <path
        fill="#7a7c7f"
        d="M233.8 1.1C105.3 1.1 1.2 55.5 1.2 122.7c0 67.2 104.1 121.6 232.6 121.6 128.4 0 232.6-54.5 232.6-121.6 0-67.2-104.2-121.6-232.6-121.6"
      />
      <path
        fill="#7b7d7f"
        d="M233.8 1.1C105.4 1.1 1.2 55.5 1.2 122.7c0 67.2 104.1 121.6 232.6 121.6 128.4 0 232.6-54.5 232.6-121.6 0-67.2-104.2-121.6-232.6-121.6"
      />
      <path
        fill="#7c7d80"
        d="M233.8 1.1C105.4 1.1 1.3 55.6 1.3 122.7c0 67.2 104.1 121.6 232.5 121.6s232.5-54.4 232.5-121.6c0-67.1-104.1-121.6-232.5-121.6"
      />
      <path
        fill="#7c7e81"
        d="M233.8 1.1C105.4 1.1 1.3 55.6 1.3 122.7s104.1 121.6 232.5 121.6 232.5-54.4 232.5-121.6c0-67.1-104.1-121.6-232.5-121.6"
      />
      <path
        fill="#7d7f82"
        d="M233.8 1.2C105.4 1.2 1.3 55.6 1.3 122.7s104.1 121.6 232.5 121.6 232.5-54.4 232.5-121.6c0-67.1-104.1-121.5-232.5-121.5"
      />
      <path
        fill="#7e8082"
        d="M233.8 1.2C105.4 1.2 1.3 55.6 1.3 122.7s104.1 121.5 232.5 121.5 232.5-54.4 232.5-121.5S362.2 1.2 233.8 1.2"
      />
      <path
        fill="#7f8083"
        d="M233.8 1.2C105.4 1.2 1.4 55.6 1.4 122.7s104.1 121.5 232.4 121.5c128.4 0 232.5-54.4 232.5-121.5C466.2 55.6 362.2 1.2 233.8 1.2"
      />
      <path
        fill="#7f8184"
        d="M233.8 1.2C105.5 1.2 1.4 55.6 1.4 122.7s104.1 121.5 232.4 121.5c128.4 0 232.4-54.4 232.4-121.5S362.1 1.2 233.8 1.2"
      />
      <path
        fill="#808285"
        d="M233.8 1.3C105.5 1.3 1.4 55.6 1.4 122.7c0 67.1 104 121.5 232.4 121.5 128.3 0 232.4-54.4 232.4-121.5S362.1 1.3 233.8 1.3"
      />
      <path
        fill="#818385"
        d="M233.8 1.3C105.5 1.3 1.5 55.7 1.5 122.7c0 67.1 104 121.4 232.4 121.4 128.3 0 232.4-54.4 232.4-121.4-.1-67-104.2-121.4-232.5-121.4"
      />
      <path
        fill="#828386"
        d="M233.8 1.3C105.5 1.3 1.5 55.7 1.5 122.7s104 121.4 232.3 121.4 232.3-54.4 232.3-121.4c.1-67-104-121.4-232.3-121.4"
      />
      <path
        fill="#828487"
        d="M233.8 1.3C105.5 1.3 1.5 55.7 1.5 122.7s104 121.4 232.3 121.4 232.3-54.4 232.3-121.4S362.1 1.3 233.8 1.3"
      />
      <path
        fill="#838588"
        d="M233.8 1.4C105.5 1.4 1.5 55.7 1.5 122.7s104 121.4 232.3 121.4 232.3-54.3 232.3-121.4c0-67-104-121.3-232.3-121.3"
      />
      <path
        fill="#848688"
        d="M233.8 1.4C105.6 1.4 1.6 55.7 1.6 122.7S105.6 244 233.8 244c128.3 0 232.3-54.3 232.3-121.3S362.1 1.4 233.8 1.4"
      />
      <path
        fill="#858689"
        d="M233.8 1.4C105.6 1.4 1.6 55.7 1.6 122.7S105.6 244 233.8 244C362.1 244 466 189.7 466 122.7c.1-67-103.9-121.3-232.2-121.3"
      />
      <path
        fill="#85878a"
        d="M233.8 1.4C105.6 1.4 1.6 55.7 1.6 122.7S105.6 244 233.8 244C362.1 244 466 189.7 466 122.7S362.1 1.4 233.8 1.4"
      />
      <path
        fill="#86888b"
        d="M233.8 1.5C105.6 1.5 1.6 55.8 1.6 122.7c0 67 104 121.3 232.2 121.3S466 189.7 466 122.7C466 55.8 362 1.5 233.8 1.5"
      />
      <path
        fill="#87898b"
        d="M233.8 1.5C105.6 1.5 1.7 55.8 1.7 122.7c0 67 103.9 121.2 232.1 121.2C362 244 466 189.7 466 122.7 466 55.8 362 1.5 233.8 1.5"
      />
      <path
        fill="#88898c"
        d="M233.8 1.5C105.6 1.5 1.7 55.8 1.7 122.7c0 67 103.9 121.3 232.1 121.3S466 189.7 466 122.7C466 55.8 362 1.5 233.8 1.5"
      />
      <path
        fill="#888a8d"
        d="M233.8 1.5C105.6 1.5 1.7 55.8 1.7 122.8 1.7 189.7 105.6 244 233.8 244s232.1-54.3 232.1-121.2c0-67-103.9-121.3-232.1-121.3"
      />
      <path
        fill="#898b8e"
        d="M233.8 1.6c-128.1 0-232 54.2-232 121.2C1.8 189.7 105.7 244 233.9 244S466 189.7 466 122.8c-.1-67-104-121.2-232.2-121.2"
      />
      <path
        fill="#8a8c8e"
        d="M233.8 1.6c-128.1 0-232 54.2-232 121.2 0 66.9 103.9 121.1 232 121.1 128.2 0 232.1-54.2 232.1-121.1 0-67-103.9-121.2-232.1-121.2"
      />
      <path
        fill="#8a8c8f"
        d="M233.8 1.6c-128.1 0-232 54.2-232 121.1 0 66.9 103.9 121.1 232 121.1s232-54.2 232-121.1C465.9 55.8 362 1.6 233.8 1.6"
      />
      <path
        fill="#8b8d90"
        d="M233.8 1.6c-128.1 0-232 54.2-232 121.1 0 66.9 103.9 121.1 232 121.1s232-54.2 232-121.1C465.9 55.9 362 1.6 233.8 1.6"
      />
      <path
        fill="#8c8e91"
        d="M233.8 1.7c-128.1 0-232 54.2-232 121.1 0 66.9 103.9 121.1 232 121.1s232-54.2 232-121.1c0-66.9-103.8-121.1-232-121.1"
      />
      <path
        fill="#8d8f91"
        d="M233.8 1.7C105.7 1.7 1.9 55.9 1.9 122.8c0 66.8 103.9 121 231.9 121 128.1 0 232-54.2 232-121 0-66.9-103.9-121.1-232-121.1"
      />
      <path
        fill="#8d8f92"
        d="M233.8 1.7C105.8 1.7 1.9 55.9 1.9 122.8c0 66.8 103.8 121 231.9 121 128.1 0 231.9-54.2 231.9-121C465.8 55.9 361.9 1.7 233.8 1.7"
      />
      <path
        fill="#8e9093"
        d="M233.8 1.7C105.8 1.7 2 55.9 2 122.8c0 66.8 103.8 121 231.9 121 128.1 0 231.9-54.2 231.9-121 0-66.9-103.9-121.1-232-121.1"
      />
      <path
        fill="#8f9194"
        d="M233.8 1.8C105.8 1.8 2 55.9 2 122.8c0 66.8 103.8 121 231.9 121 128.1 0 231.9-54.2 231.9-121-.1-66.9-103.9-121-232-121"
      />
      <path
        fill="#909294"
        d="M233.9 1.8C105.8 1.8 2 55.9 2 122.8c0 66.8 103.8 121 231.8 121s231.9-54.2 231.9-121c0-66.9-103.8-121-231.8-121"
      />
      <path
        fill="#909395"
        d="M233.9 1.8C105.8 1.8 2 56 2 122.8s103.8 120.9 231.8 120.9 231.8-54.1 231.8-120.9c.1-66.8-103.7-121-231.7-121"
      />
      <path
        fill="#919396"
        d="M233.9 1.8C105.8 1.8 2.1 56 2.1 122.8s103.8 120.9 231.8 120.9 231.8-54.1 231.8-120.9c0-66.8-103.8-121-231.8-121"
      />
      <path
        fill="#929497"
        d="M233.9 1.9C105.9 1.9 2.1 56 2.1 122.8c0 66.8 103.8 120.9 231.8 120.9s231.8-54.1 231.8-120.9C465.7 56 361.9 1.9 233.9 1.9"
      />
      <path
        fill="#939597"
        d="M233.9 1.9C105.9 1.9 2.1 56 2.1 122.8c0 66.7 103.8 120.9 231.7 120.9 128 0 231.8-54.1 231.8-120.9C465.6 56 361.8 1.9 233.9 1.9"
      />
      <path
        fill="#939698"
        d="M233.9 1.9C105.9 1.9 2.1 56 2.1 122.8c0 66.7 103.7 120.8 231.7 120.8 128 0 231.7-54.1 231.7-120.8C465.6 56 361.8 1.9 233.9 1.9"
      />
      <path
        fill="#949699"
        d="M233.9 1.9C105.9 1.9 2.2 56 2.2 122.8c0 66.7 103.7 120.8 231.7 120.8 128 0 231.7-54.1 231.7-120.8C465.6 56 361.8 1.9 233.9 1.9"
      />
      <path
        fill="#95979a"
        d="M233.9 2C105.9 2 2.2 56 2.2 122.8c0 66.7 103.7 120.8 231.7 120.8 127.9 0 231.7-54.1 231.7-120.8C465.6 56 361.8 2 233.9 2"
      />
      <path
        fill="#96989a"
        d="M233.9 2C105.9 2 2.2 56.1 2.2 122.8c0 66.7 103.7 120.8 231.6 120.8 127.9 0 231.7-54.1 231.7-120.8C465.5 56.1 361.8 2 233.9 2"
      />
      <path
        fill="#97999b"
        d="M233.9 2C106 2 2.3 56.1 2.3 122.8c0 66.7 103.7 120.7 231.6 120.7 127.9 0 231.6-54.1 231.6-120.7C465.5 56.1 361.8 2 233.9 2"
      />
      <path
        fill="#97999c"
        d="M233.9 2C106 2 2.3 56.1 2.3 122.8c0 66.7 103.7 120.7 231.6 120.7 127.9 0 231.6-54.1 231.6-120.7C465.5 56.1 361.8 2 233.9 2"
      />
      <path
        fill="#989a9d"
        d="M233.9 2.1C106 2.1 2.3 56.1 2.3 122.8c0 66.6 103.7 120.7 231.6 120.7 127.9 0 231.6-54 231.6-120.7S361.8 2.1 233.9 2.1"
      />
      <path
        fill="#999b9e"
        d="M233.9 2.1C106 2.1 2.3 56.1 2.3 122.8c0 66.6 103.7 120.7 231.5 120.7 127.9 0 231.6-54 231.6-120.7S361.8 2.1 233.9 2.1"
      />
      <path
        fill="#9a9c9e"
        d="M233.9 2.1C106 2.1 2.4 56.1 2.4 122.8c0 66.6 103.7 120.6 231.5 120.6 127.9 0 231.5-54 231.5-120.6 0-66.7-103.7-120.7-231.5-120.7"
      />
      <path
        fill="#9a9c9f"
        d="M233.9 2.1C106 2.1 2.4 56.1 2.4 122.8c0 66.6 103.6 120.6 231.5 120.6 127.8 0 231.5-54 231.5-120.6 0-66.7-103.7-120.7-231.5-120.7"
      />
      <path
        fill="#9b9da0"
        d="M233.9 2.2C106.1 2.2 2.4 56.2 2.4 122.8S106 243.4 233.9 243.4c127.8 0 231.5-54 231.5-120.6S361.7 2.2 233.9 2.2"
      />
      <path
        fill="#9c9ea1"
        d="M233.9 2.2C106.1 2.2 2.5 56.2 2.5 122.8s103.6 120.6 231.4 120.6c127.8 0 231.5-54 231.5-120.6S361.7 2.2 233.9 2.2"
      />
      <path
        fill="#9d9fa1"
        d="M233.9 2.2C106.1 2.2 2.5 56.2 2.5 122.8s103.6 120.5 231.4 120.5c127.8 0 231.4-54 231.4-120.5 0-66.6-103.6-120.6-231.4-120.6"
      />
      <path
        fill="#9da0a2"
        d="M233.9 2.2C106.1 2.2 2.5 56.2 2.5 122.8s103.6 120.5 231.4 120.5c127.8 0 231.4-54 231.4-120.5 0-66.6-103.6-120.6-231.4-120.6"
      />
      <path
        fill="#9ea0a3"
        d="M233.9 2.3C106.1 2.3 2.5 56.2 2.5 122.8c0 66.5 103.6 120.5 231.4 120.5 127.8 0 231.4-54 231.4-120.5 0-66.6-103.6-120.5-231.4-120.5"
      />
      <path
        fill="#9fa1a4"
        d="M233.9 2.3C106.1 2.3 2.6 56.2 2.6 122.8c0 66.5 103.6 120.5 231.3 120.5 127.8 0 231.4-53.9 231.4-120.5S361.7 2.3 233.9 2.3"
      />
      <path
        fill="#a0a2a4"
        d="M233.9 2.3C106.2 2.3 2.6 56.2 2.6 122.8c0 66.5 103.6 120.5 231.3 120.5 127.8 0 231.3-53.9 231.3-120.5S361.7 2.3 233.9 2.3"
      />
      <path
        fill="#a1a3a5"
        d="M233.9 2.3C106.2 2.3 2.6 56.3 2.6 122.8s103.6 120.4 231.3 120.4c127.7 0 231.3-53.9 231.3-120.4S361.6 2.3 233.9 2.3"
      />
      <path
        fill="#a1a3a6"
        d="M233.9 2.4C106.2 2.4 2.6 56.3 2.6 122.8s103.5 120.4 231.3 120.4c127.7 0 231.3-53.9 231.3-120.4S361.6 2.4 233.9 2.4"
      />
      <path
        fill="#a2a4a7"
        d="M233.9 2.4C106.2 2.4 2.7 56.3 2.7 122.8s103.5 120.4 231.2 120.4c127.7 0 231.3-53.9 231.3-120.4S361.6 2.4 233.9 2.4"
      />
      <path
        fill="#a3a5a8"
        d="M233.9 2.4C106.2 2.4 2.7 56.3 2.7 122.8s103.5 120.4 231.2 120.4c127.7 0 231.2-53.9 231.2-120.4S361.6 2.4 233.9 2.4"
      />
      <path
        fill="#a4a6a8"
        d="M233.9 2.4C106.2 2.4 2.7 56.3 2.7 122.8s103.5 120.3 231.2 120.3c127.7 0 231.2-53.9 231.2-120.3 0-66.5-103.5-120.4-231.2-120.4"
      />
      <path
        fill="#a4a7a9"
        d="M233.9 2.5C106.3 2.5 2.8 56.3 2.8 122.8c0 66.4 103.5 120.3 231.2 120.3 127.7 0 231.2-53.9 231.2-120.3C465.1 56.3 361.6 2.5 233.9 2.5"
      />
      <path
        fill="#a5a7aa"
        d="M233.9 2.5C106.3 2.5 2.8 56.3 2.8 122.8c0 66.4 103.5 120.3 231.1 120.3 127.7 0 231.2-53.9 231.2-120.3 0-66.5-103.5-120.3-231.2-120.3"
      />
      <path
        fill="#a6a8ab"
        d="M233.9 2.5C106.3 2.5 2.8 56.4 2.8 122.8S106.3 243 233.9 243 465 189.2 465 122.7C465.1 56.4 361.6 2.5 233.9 2.5"
      />
      <path
        fill="#a7a9ac"
        d="M233.9 2.5C106.3 2.5 2.8 56.4 2.8 122.8S106.3 243 233.9 243C361.6 243 465 189.2 465 122.8S361.6 2.5 233.9 2.5"
      />
      <path
        fill="#a8aaac"
        d="M233.9 2.6c-127.6 0-231 53.8-231 120.2S106.3 243 233.9 243 465 189.2 465 122.8 361.5 2.6 233.9 2.6"
      />
      <path
        fill="#a8abad"
        d="M233.9 2.6c-127.6 0-231 53.8-231 120.2S106.3 243 233.9 243 465 189.2 465 122.8 361.5 2.6 233.9 2.6"
      />
      <path
        fill="#a9abae"
        d="M233.9 2.6c-127.6 0-231 53.8-231 120.2S106.3 243 233.9 243s231-53.8 231-120.2C465 56.4 361.5 2.6 233.9 2.6"
      />
      <path
        fill="#aaacaf"
        d="M233.9 2.6C106.4 2.6 3 56.4 3 122.8c0 66.3 103.4 120.1 231 120.1s231-53.8 231-120.1C464.9 56.4 361.5 2.6 233.9 2.6"
      />
      <path
        fill="#abadaf"
        d="M233.9 2.7C106.4 2.7 3 56.4 3 122.8c0 66.3 103.4 120.1 231 120.1s231-53.8 231-120.1C464.9 56.4 361.5 2.7 233.9 2.7"
      />
      <path
        fill="#acaeb0"
        d="M233.9 2.7C106.4 2.7 3 56.5 3 122.8s103.4 120.1 230.9 120.1 231-53.8 231-120.1S361.5 2.7 233.9 2.7"
      />
      <path
        fill="#acafb1"
        d="M233.9 2.7C106.4 2.7 3 56.5 3 122.8s103.4 120.1 230.9 120.1 230.9-53.8 230.9-120.1C464.9 56.5 361.5 2.7 233.9 2.7"
      />
      <path
        fill="#adafb2"
        d="M233.9 2.7C106.4 2.7 3.1 56.5 3.1 122.8s103.4 120 230.9 120 230.9-53.8 230.9-120c-.1-66.3-103.4-120.1-231-120.1"
      />
      <path
        fill="#aeb0b3"
        d="M234 2.8C106.5 2.8 3.1 56.5 3.1 122.8s103.4 120 230.9 120 230.9-53.7 230.9-120c-.1-66.3-103.5-120-230.9-120"
      />
      <path
        fill="#afb1b3"
        d="M234 2.8C106.5 2.8 3.1 56.5 3.1 122.8s103.4 120 230.8 120c127.5 0 230.9-53.7 230.9-120S361.4 2.8 234 2.8"
      />
      <path
        fill="#b0b2b4"
        d="M234 2.8C106.5 2.8 3.2 56.5 3.2 122.8s103.3 120 230.8 120c127.5 0 230.8-53.7 230.8-120S361.4 2.8 234 2.8"
      />
      <path
        fill="#b1b3b5"
        d="M234 2.8C106.5 2.8 3.2 56.5 3.2 122.8c0 66.2 103.3 120 230.8 120 127.5 0 230.8-53.7 230.8-120S361.4 2.8 234 2.8"
      />
      <path
        fill="#b1b3b6"
        d="M234 2.9C106.5 2.9 3.2 56.6 3.2 122.8S106.5 242.7 234 242.7c127.4 0 230.8-53.7 230.8-119.9C464.7 56.6 361.4 2.9 234 2.9"
      />
      <path
        fill="#b2b4b7"
        d="M234 2.9C106.5 2.9 3.2 56.6 3.2 122.8S106.5 242.7 234 242.7c127.4 0 230.7-53.7 230.7-119.9S361.4 2.9 234 2.9"
      />
      <path
        fill="#b3b5b7"
        d="M234 2.9C106.6 2.9 3.3 56.6 3.3 122.8S106.6 242.7 234 242.7c127.4 0 230.7-53.7 230.7-119.9S361.4 2.9 234 2.9"
      />
      <path
        fill="#b4b6b8"
        d="M234 2.9C106.6 2.9 3.3 56.6 3.3 122.8S106.6 242.7 234 242.7c127.4 0 230.7-53.7 230.7-119.9S361.4 2.9 234 2.9"
      />
      <path
        fill="#b5b7b9"
        d="M234 3C106.6 3 3.3 56.6 3.3 122.8 3.3 189 106.6 242.6 234 242.6c127.4 0 230.7-53.7 230.7-119.8C464.6 56.6 361.4 3 234 3"
      />
      <path
        fill="#b5b7ba"
        d="M234 3C106.6 3 3.3 56.6 3.3 122.8 3.3 189 106.6 242.6 234 242.6c127.4 0 230.6-53.6 230.6-119.8C464.6 56.6 361.3 3 234 3"
      />
      <path
        fill="#b6b8bb"
        d="M234 3C106.6 3 3.4 56.6 3.4 122.8 3.4 189 106.6 242.6 234 242.6c127.4 0 230.6-53.6 230.6-119.8C464.6 56.6 361.3 3 234 3"
      />
      <path
        fill="#b7b9bb"
        d="M234 3C106.6 3 3.4 56.7 3.4 122.8S106.6 242.6 234 242.6c127.3 0 230.6-53.6 230.6-119.8C464.6 56.7 361.3 3 234 3"
      />
      <path
        fill="#b8babc"
        d="M234 3.1C106.7 3.1 3.4 56.7 3.4 122.8S106.6 242.5 234 242.5c127.3 0 230.6-53.6 230.6-119.7S361.3 3.1 234 3.1"
      />
      <path
        fill="#b9bbbd"
        d="M234 3.1C106.7 3.1 3.5 56.7 3.5 122.8S106.7 242.5 234 242.5s230.5-53.6 230.5-119.7S361.3 3.1 234 3.1"
      />
      <path
        fill="#babbbe"
        d="M234 3.1C106.7 3.1 3.5 56.7 3.5 122.8S106.7 242.5 234 242.5s230.5-53.6 230.5-119.7S361.3 3.1 234 3.1"
      />
      <path
        fill="#babcbf"
        d="M234 3.1C106.7 3.1 3.5 56.7 3.5 122.8S106.7 242.5 234 242.5s230.5-53.6 230.5-119.7S361.3 3.1 234 3.1"
      />
      <path
        fill="#bbbdbf"
        d="M234 3.2C106.7 3.2 3.5 56.7 3.5 122.8s103.2 119.6 230.4 119.6c127.3 0 230.5-53.6 230.5-119.6C464.5 56.7 361.3 3.2 234 3.2"
      />
      <path
        fill="#bcbec0"
        d="M234 3.2C106.7 3.2 3.6 56.7 3.6 122.8S106.8 242.4 234 242.4c127.3 0 230.4-53.6 230.4-119.6C464.4 56.7 361.3 3.2 234 3.2"
      />
      <path
        fill="#bdbfc1"
        d="M234 3.2C106.8 3.2 3.6 56.8 3.6 122.8S106.8 242.4 234 242.4s230.4-53.6 230.4-119.6S361.2 3.2 234 3.2"
      />
      <path
        fill="#bec0c2"
        d="M234 3.2C106.8 3.2 3.6 56.8 3.6 122.8S106.7 242.4 234 242.4c127.2 0 230.4-53.5 230.4-119.6 0-66-103.2-119.6-230.4-119.6"
      />
      <path
        fill="#bfc0c3"
        d="M234 3.3C106.8 3.3 3.7 56.8 3.7 122.8S106.8 242.3 234 242.3c127.2 0 230.4-53.5 230.4-119.5S361.2 3.3 234 3.3"
      />
      <path
        fill="#bfc1c3"
        d="M234 3.3C106.8 3.3 3.7 56.8 3.7 122.8S106.8 242.3 234 242.3c127.2 0 230.3-53.5 230.3-119.5S361.2 3.3 234 3.3"
      />
      <path
        fill="#c0c2c4"
        d="M234 3.3C106.8 3.3 3.7 56.8 3.7 122.8S106.8 242.3 234 242.3c127.2 0 230.3-53.5 230.3-119.5S361.2 3.3 234 3.3"
      />
      <path
        fill="#c1c3c5"
        d="M234 3.3C106.8 3.3 3.7 56.8 3.7 122.8S106.8 242.3 234 242.3c127.2 0 230.3-53.5 230.3-119.5S361.2 3.3 234 3.3"
      />
      <path
        fill="#c2c4c6"
        d="M234 3.4C106.9 3.4 3.8 56.8 3.8 122.8S106.9 242.3 234 242.3c127.2 0 230.3-53.5 230.3-119.5S361.2 3.4 234 3.4"
      />
      <path
        fill="#c3c4c7"
        d="M234 3.4C106.9 3.4 3.8 56.9 3.8 122.8S106.9 242.2 234 242.2s230.2-53.5 230.2-119.4C464.3 56.9 361.2 3.4 234 3.4"
      />
      <path
        fill="#c4c5c7"
        d="M234 3.4C106.9 3.4 3.8 56.9 3.8 122.8S106.9 242.2 234 242.2s230.2-53.5 230.2-119.4S361.1 3.4 234 3.4"
      />
      <path
        fill="#c4c6c8"
        d="M234 3.4C106.9 3.4 3.8 56.9 3.8 122.8S106.9 242.2 234 242.2s230.2-53.5 230.2-119.4S361.1 3.4 234 3.4"
      />
      <path
        fill="#c5c7c9"
        d="M234 3.5C106.9 3.5 3.9 56.9 3.9 122.8s103 119.4 230.1 119.4 230.2-53.4 230.2-119.4C464.2 56.9 361.1 3.5 234 3.5"
      />
      <path
        fill="#c6c8ca"
        d="M234 3.5C106.9 3.5 3.9 56.9 3.9 122.8s103 119.3 230.1 119.3 230.1-53.4 230.1-119.3C464.2 56.9 361.1 3.5 234 3.5"
      />
      <path
        fill="#c7c9cb"
        d="M234 3.5C107 3.5 3.9 56.9 3.9 122.8s103 119.3 230.1 119.3 230.1-53.4 230.1-119.3S361.1 3.5 234 3.5"
      />
      <path
        fill="#c8c9cb"
        d="M234 3.5C107 3.5 4 56.9 4 122.8s103 119.3 230 119.3c127.1 0 230.1-53.4 230.1-119.3S361.1 3.5 234 3.5"
      />
      <path
        fill="#c9cacc"
        d="M234 3.6C107 3.6 4 56.9 4 122.8s103 119.3 230 119.3 230.1-53.4 230.1-119.3S361.1 3.6 234 3.6"
      />
      <path
        fill="#c9cbcd"
        d="M234 3.6C107 3.6 4 57 4 122.8 4 188.6 107 242 234 242s230-53.4 230-119.2C464.1 57 361.1 3.6 234 3.6"
      />
      <path
        fill="#caccce"
        d="M234 3.6C107 3.6 4 57 4 122.8 4 188.7 107 242 234 242s230-53.4 230-119.2C464.1 57 361.1 3.6 234 3.6"
      />
      <path
        fill="#cbcdce"
        d="M234 3.6C107 3.6 4.1 57 4.1 122.8 4.1 188.6 107 242 234 242s230-53.4 230-119.2C464 57 361 3.6 234 3.6"
      />
      <path
        fill="#cccdcf"
        d="M234 3.7C107.1 3.7 4.1 57 4.1 122.8S107.1 242 234 242c127 0 230-53.4 230-119.2C464 57 361 3.7 234 3.7"
      />
      <path
        fill="#cdced0"
        d="M234 3.7C107.1 3.7 4.1 57 4.1 122.8S107.1 242 234 242c127 0 230-53.4 230-119.2C464 57 361 3.7 234 3.7"
      />
      <path
        fill="#cecfd1"
        d="M234 3.7C107.1 3.7 4.2 57 4.2 122.8s102.9 119.1 229.9 119.1S464 188.6 464 122.8 361 3.7 234 3.7"
      />
      <path
        fill="#ced0d2"
        d="M234 3.7C107.1 3.7 4.2 57 4.2 122.8s102.9 119.1 229.9 119.1S464 188.6 464 122.8C463.9 57 361 3.7 234 3.7"
      />
      <path
        fill="#cfd1d2"
        d="M234.1 3.8c-127 0-229.9 53.3-229.9 119 0 65.8 102.9 119.1 229.8 119.1s229.9-53.3 229.9-119.1c0-65.7-102.9-119-229.8-119"
      />
      <path
        fill="#d0d1d3"
        d="M234.1 3.8c-127 0-229.9 53.3-229.9 119s102.9 119 229.8 119 229.8-53.3 229.8-119c.1-65.7-102.8-119-229.7-119"
      />
      <path
        fill="#d1d2d4"
        d="M234.1 3.8C107.2 3.8 4.3 57.1 4.3 122.8s102.9 119 229.8 119 229.8-53.3 229.8-119S361 3.8 234.1 3.8"
      />
      <path
        fill="#d2d3d5"
        d="M234.1 3.8C107.2 3.8 4.3 57.1 4.3 122.8s102.9 119 229.8 119 229.8-53.3 229.8-119c-.1-65.7-102.9-119-229.8-119"
      />
      <path
        fill="#d2d4d6"
        d="M234.1 3.9C107.2 3.9 4.3 57.1 4.3 122.8s102.9 119 229.7 119c126.9 0 229.8-53.3 229.8-119S360.9 3.9 234.1 3.9"
      />
      <path
        fill="#d3d5d6"
        d="M234.1 3.9C107.2 3.9 4.4 57.1 4.4 122.8s102.9 118.9 229.7 118.9c126.9 0 229.7-53.3 229.7-118.9 0-65.7-102.9-118.9-229.7-118.9"
      />
      <path
        fill="#d4d6d7"
        d="M234.1 3.9C107.2 3.9 4.4 57.1 4.4 122.8s102.8 118.9 229.7 118.9c126.9 0 229.7-53.3 229.7-118.9 0-65.7-102.9-118.9-229.7-118.9"
      />
      <path
        fill="#d5d6d8"
        d="M234.1 3.9C107.2 3.9 4.4 57.2 4.4 122.8c0 65.7 102.8 118.9 229.7 118.9 126.8 0 229.7-53.2 229.7-118.9 0-65.6-102.9-118.9-229.7-118.9"
      />
      <path
        fill="#d6d7d9"
        d="M234.1 4C107.3 4 4.4 57.2 4.4 122.8S107.2 241.7 234 241.7s229.7-53.2 229.7-118.9C463.7 57.2 360.9 4 234.1 4"
      />
      <path
        fill="#d7d8d9"
        d="M234.1 4C107.3 4 4.5 57.2 4.5 122.8s102.8 118.9 229.6 118.9 229.6-53.2 229.6-118.9C463.7 57.2 360.9 4 234.1 4"
      />
      <path
        fill="#d7d9da"
        d="M234.1 4C107.3 4 4.5 57.2 4.5 122.8s102.8 118.8 229.6 118.8 229.6-53.2 229.6-118.8S360.9 4 234.1 4"
      />
      <path
        fill="#d8dadb"
        d="M234.1 4C107.3 4 4.5 57.2 4.5 122.8s102.8 118.8 229.6 118.8 229.6-53.2 229.6-118.8S360.9 4 234.1 4"
      />
      <path
        fill="#d9dadc"
        d="M234.1 4.1C107.3 4.1 4.5 57.2 4.5 122.8S107.3 241.6 234 241.6c126.8 0 229.6-53.2 229.6-118.8S360.9 4.1 234.1 4.1"
      />
      <path
        fill="#dadbdd"
        d="M234.1 4.1C107.3 4.1 4.6 57.2 4.6 122.8s102.8 118.8 229.5 118.8c126.8 0 229.5-53.2 229.5-118.8S360.8 4.1 234.1 4.1"
      />
      <path
        fill="#dbdcdd"
        d="M234.1 4.1C107.4 4.1 4.6 57.3 4.6 122.8c0 65.6 102.8 118.7 229.5 118.7s229.5-53.2 229.5-118.7S360.8 4.1 234.1 4.1"
      />
      <path
        fill="#dcddde"
        d="M234.1 4.1C107.4 4.1 4.6 57.3 4.6 122.8c0 65.6 102.7 118.7 229.5 118.7 126.7 0 229.5-53.2 229.5-118.7S360.8 4.1 234.1 4.1"
      />
      <path
        fill="#dcdedf"
        d="M234.1 4.2C107.4 4.2 4.7 57.3 4.7 122.8s102.7 118.7 229.4 118.7 229.5-53.1 229.5-118.7C463.5 57.3 360.8 4.2 234.1 4.2"
      />
      <path
        fill="#dddee0"
        d="M234.1 4.2C107.4 4.2 4.7 57.3 4.7 122.8s102.7 118.7 229.4 118.7 229.4-53.1 229.4-118.7c0-65.5-102.7-118.6-229.4-118.6"
      />
      <path
        fill="#dedfe0"
        d="M234.1 4.2C107.4 4.2 4.7 57.3 4.7 122.8s102.7 118.6 229.4 118.6 229.4-53.1 229.4-118.6S360.8 4.2 234.1 4.2"
      />
      <path
        fill="#dfe0e1"
        d="M234.1 4.2C107.4 4.2 4.7 57.3 4.7 122.8s102.7 118.6 229.4 118.6 229.4-53.1 229.4-118.6S360.8 4.2 234.1 4.2"
      />
      <path
        fill="#e0e1e2"
        d="M234.1 4.3C107.5 4.3 4.8 57.3 4.8 122.8s102.7 118.6 229.3 118.6c126.7 0 229.4-53.1 229.4-118.6S360.8 4.3 234.1 4.3"
      />
      <path
        fill="#e0e2e3"
        d="M234.1 4.3C107.5 4.3 4.8 57.4 4.8 122.8c0 65.5 102.7 118.6 229.3 118.6 126.6 0 229.3-53.1 229.3-118.6 0-65.4-102.7-118.5-229.3-118.5"
      />
      <path
        fill="#e1e2e3"
        d="M234.1 4.3C107.5 4.3 4.8 57.4 4.8 122.8c0 65.5 102.7 118.5 229.3 118.5 126.6 0 229.3-53.1 229.3-118.5S360.7 4.3 234.1 4.3"
      />
      <path
        fill="#e2e3e4"
        d="M234.1 4.3C107.5 4.3 4.9 57.4 4.9 122.9c0 65.4 102.6 118.5 229.3 118.5 126.6 0 229.3-53.1 229.3-118.5C463.4 57.4 360.7 4.3 234.1 4.3"
      />
      <path
        fill="#e3e4e5"
        d="M234.1 4.4C107.5 4.4 4.9 57.4 4.9 122.9c0 65.4 102.6 118.5 229.2 118.5s229.3-53.1 229.3-118.5c0-65.5-102.7-118.5-229.3-118.5"
      />
      <path
        fill="#e4e5e6"
        d="M234.1 4.4C107.5 4.4 4.9 57.4 4.9 122.9c0 65.4 102.6 118.5 229.2 118.5s229.2-53.1 229.2-118.5c0-65.5-102.6-118.5-229.2-118.5"
      />
      <path
        fill="#e5e6e7"
        d="M234.1 4.4C107.6 4.4 4.9 57.4 4.9 122.9c0 65.4 102.6 118.4 229.2 118.4s229.2-53 229.2-118.4c0-65.5-102.6-118.5-229.2-118.5"
      />
      <path
        fill="#e5e6e7"
        d="M234.1 4.4C107.6 4.4 5 57.4 5 122.9c0 65.4 102.6 118.4 229.2 118.4s229.2-53 229.2-118.4C463.3 57.4 360.7 4.4 234.1 4.4"
      />
      <path
        fill="#e6e7e8"
        d="M234.1 4.5C107.6 4.5 5 57.5 5 122.9s102.6 118.4 229.1 118.4 229.2-53 229.2-118.4S360.7 4.5 234.1 4.5"
      />
      <path
        fill="none"
        d="M233.7 9.7c-124 0-224.5 50.6-224.5 113s100.5 113 224.5 113 224.5-50.6 224.5-113-100.5-113-224.5-113"
      />
      <linearGradient
        id="aGradLand"
        x1="174.665"
        x2="292.683"
        y1="-3.865"
        y2="249.225"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#008948" />
        <stop offset=".042" stopColor="#008847" />
        <stop offset=".096" stopColor="#008244" />
        <stop offset=".157" stopColor="#00793f" />
        <stop offset=".222" stopColor="#006a37" />
        <stop offset=".291" stopColor="#00572b" />
        <stop offset=".319" stopColor="#004e24" />
        <stop offset="1" />
      </linearGradient>
      <path
        fill="url(#aGradLand)"
        d="M233.7 9.7c-124 0-224.5 50.6-224.5 113s100.5 113 224.5 113 224.5-50.6 224.5-113-100.5-113-224.5-113"
      />
      <path
        fill="none"
        stroke="#004e24"
        strokeWidth="2.894"
        d="M233.7 23.2c-116.2 0-210.4 45-210.4 100.5s94.2 100.5 210.4 100.5 210.4-45 210.4-100.5S349.9 23.2 233.7 23.2"
      />
      <path
        fill="none"
        stroke="#f5f0cc"
        strokeWidth="5.487"
        d="M233.7 17.3c-119.3 0-216 47.3-216 105.5 0 58.3 96.7 105.5 216 105.5S449.8 181 449.8 122.8C449.7 64.6 353 17.3 233.7 17.3"
      />
      <path
        fill="#f5f0cc"
        d="M363.3 74.8H328l-4.3 12.9h22.8l-26 9.4-1.7 5.2 40.1-13.7 4.4-13.8M141.9 96.4l-4.8 13.7h-34.4s.8-.3 1.9-2.6c1.1-2.3 17-48.6 17-48.6s2.2-4.9-.3-6.1h19.9s-1.1-.3-3 4.6c-1.1 2.8-14.4 40-14.4 40h14.4s3.3.3 3.7-1M198.5 110.1h16.2s-1.1-1.7-.4-3.6c.9-2.6 9.5-27.1 9.5-27.1l3.8 30.7h14.7l19.2-54.6s.8-2.6 1.9-2.6h-15.6s.4 1.9-.1 3.3c-.6 1.5-9.4 26.2-9.4 26.2l-3.5-29.5H218s.9 1.5.3 3c-.5 1.3-17.8 51-17.8 51s-1 3.2-2 3.2M291 52.9h-18.4s1.4 2.3-.4 7.7c-1.8 5.4-15.9 45.2-15.9 45.2s-1.1 3.8-2.6 4.5h22.2s26.9 1.1 35.2-28.5c-.1-.1 10.4-29.2-20.1-28.9zm2 31.3c-4.7 12-11.7 12.8-15.4 12.8H275l10.8-31.8h4.2c-.1 0 10.7-.6 3 19zM78.1 156.3h35.3l4.3-12.9H94.8l26.1-9.4 1.7-5.2-40.1 13.8-4.4 13.7M178.6 144.3c6.6-22.2-15.7-21.6-15.7-21.6H140c1.7 1.9.4 6 .4 6s-14.2 42.5-15.3 45.8c-1.1 3.3-3.1 5.5-3.1 5.5h18.1c-.6 0-.6-1.9-.6-1.9l6.5-18s8.1 16.6 8.7 17.7c.5 1.2.3 2.1.3 2.1h19.3c-1.9 0-3.8-3.7-3.8-3.7l-9.6-18.1c13.3.2 17.7-13.8 17.7-13.8zm-15.8-2c-2.5 5.7-9.4 5-9.4 5h-3.5l3.7-11.5h3.8c8.3 0 5.4 6.5 5.4 6.5zM378.3 145c7.1-23.3-15.5-22.1-15.5-22.1h-22.7c1.7 1.9.4 6 .4 6s-14.8 42.7-15.9 45.9c-1.1 3.3-3.2 5.4-3.2 5.4h18.9c-1.4 0-.4-3.5-.4-3.5l5.8-16.4s7.8 16.6 8.4 17.7c.6 1.2.3 2.1.3 2.1h20c-1.9 0-3.9-3.7-3.9-3.7l-9.6-18.1c13.4.2 17.4-13.3 17.4-13.3zm-16-2.4c-2.1 5.5-8.9 5-8.9 5h-3.5l3.7-11.4h5s6.1-.2 3.7 6.4zM214.5 121.2c-17.7 0-29.2 14-32.2 31.4-2.7 16 5.9 28.8 20.2 28.8 20 0 31.9-20.5 31.9-35.2 0-15.4-6.1-25-19.9-25zm2.6 31.9c-2.9 12-8.4 15.7-13.3 14.8-6.8-1.3-5.6-12.3-4.5-17.4 2.4-11.1 8.3-16.4 12.7-15.9 1.4.2 9.4.4 5.1 18.5zM239.1 122.9s1.4.8 1.4 4.4v49.6s-.2 2.7-1.2 3.3h14.8s0-1.2 1.5-3.1c1.5-1.9 32.3-45.2 32.3-45.2s7-9.1 8.9-9.1h-21.3s1.7 1.2.4 3.3c-1.3 2.1-20.2 31.7-20.2 31.7l.3-29.8s0-4.8 1.8-5.2l-18.7.1M328.9 136.4l4.8-13.5h-36s1.3 1.2-.4 6c-1.7 4.8-16.3 45.9-16.3 45.9s-2.6 5.4-3.3 5.4h37.1l4.4-13.7s-.6.8-4.1.8h-15.7l3.3-9.3H315s2.6-.2 3.1.6l5-14.7s-.4 1.3-3.7 1.3h-11.8l3.5-10.2h15c0 .1 2-.2 2.8 1.4M196.6 110.2s-1.3-.8-1.6-3.1l-2.2-50.4s-.1-3.2 1.4-3.9h-17.6s1.2 1.6-1.1 5.2c-2.4 3.6-32.4 50.2-32.4 50.2s-.6 1.2-2.1 1.9h17.8s-.1-1.4.4-2.4c.8-1.7 3-5.7 3-5.7h17.9v5s.1 1.8-1.2 3.1h17.7zm-26.7-21.1l9.9-16.8.1 16.8h-10z"
      />
    </svg>
  );
}
export default LandIcon;
